import React from 'react';

import type { Participants } from '@swf/sports/types/event';
import { EventTypeId } from '@swf/sports/types/eventType';
import type { Orientation } from '@swf/sports/types/liveData';

import FootballUnavailable from './components/FootballUnavailable/FootballUnavailable';
import TennisUnavailable from './components/TennisUnavailable/TennisUnavailable';

interface Props {
  participants: Participants;
  eventTypeId: EventTypeId;
  isLoading?: boolean;
  orientation: Orientation;
}

const Unavailable: React.FC<Props> = ({ participants, eventTypeId, isLoading, orientation }) => {
  switch (eventTypeId) {
    case EventTypeId.SOCCER:
      return (
        <FootballUnavailable
          participants={participants}
          isLoading={isLoading}
          orientation={orientation}
        />
      );
    case EventTypeId.TENNIS:
      return <TennisUnavailable participants={participants} isLoading={isLoading} />;
    default:
      return null;
  }
};

export default Unavailable;
